import request from '@/utils/request';

// 基地列表
export function querySeleniumJourneyBasePageList(data) {
  return request({
    url: '/selenium/journey/base/querySeleniumJourneyBasePageList',
    method: 'POST',
    data
  });
}
// 基地列表-新增
export function saveSeleniumJourneyBase(data) {
  return request({
    url: '/selenium/journey/base/saveSeleniumJourneyBase',
    method: 'POST',
    data
  });
}
// 基地列表-编辑
export function updateSeleniumJourneyBase(data) {
  return request({
    url: '/selenium/journey/base/updateSeleniumJourneyBase',
    method: 'POST',
    data
  });
}
// 基地列表-编辑明细
export function fetchSeleniumJourneyBaseDetailById(data) {
  return request({
    url: '/selenium/journey/base/fetchSeleniumJourneyBaseDetailById',
    method: 'POST',
    data
  });
}
// 基地列表-删除
export function removeSeleniumJourneyBaseById(data) {
  return request({
    url: '/selenium/journey/base/removeSeleniumJourneyBaseById',
    method: 'POST',
    data
  });
}
// 基地商品列表
export function querySeleniumJourneyGoodsPageList(data) {
  return request({
    url: '/selenium/journey/goods/querySeleniumJourneyGoodsPageList',
    method: 'POST',
    data
  });
}
// 基地商品列表-新增
export function saveSeleniumJourneyGoods(data) {
  return request({
    url: '/selenium/journey/goods/saveSeleniumJourneyGoods',
    method: 'POST',
    data
  });
}
// 基地商品列表-编辑
export function updateSeleniumJourneyGoods(data) {
  return request({
    url: '/selenium/journey/goods/updateSeleniumJourneyGoods',
    method: 'POST',
    data
  });
}
// 基地商品列表-编辑明细
export function fetchSeleniumJourneyGoodsDetailById(data) {
  return request({
    url: '/selenium/journey/goods/fetchSeleniumJourneyGoodsDetailById',
    method: 'POST',
    data
  });
}
// 基地商品列表-删除
export function removeSeleniumJourneyGoodsById(data) {
  return request({
    url: '/selenium/journey/goods/removeSeleniumJourneyGoodsById',
    method: 'POST',
    data
  });
}
// 基地商品列表-查询所有上架的商品列表
export function queryOnlineGoodsList(data) {
  return request({
    url: '/selenium/journey/goods/queryOnlineGoodsList',
    method: 'POST',
    data
  });
}
// 获取所有基地列表
export function queryAllSeleniumJourneyBaseList(data) {
  return request({
    url: '/selenium/journey/base/queryAllSeleniumJourneyBaseList',
    method: 'POST',
    data
  });
}

/* 视频分类-列表 */
export function querySeleniumJourneyVideoCategoryPageList(data) {
  return request({
    url: '/selenium/journey/video/category/querySeleniumJourneyVideoCategoryPageList',
    method: 'POST',
    data
  });
}
/* 视频分类-删除 */
export function removeSeleniumJourneyVideoCategoryById(data) {
  return request({
    url: '/selenium/journey/video/category/removeSeleniumJourneyVideoCategoryById',
    method: 'POST',
    data
  });
}
/* 视频分类-修改状态 */
export function updateCategoryStatus(data) {
  return request({
    url: '/selenium/journey/video/category/updateCategoryStatus',
    method: 'POST',
    data
  });
}
/* 视频分类-新增 */
export function saveSeleniumJourneyVideoCategory(data) {
  return request({
    url: '/selenium/journey/video/category/saveSeleniumJourneyVideoCategory',
    method: 'POST',
    data
  });
}
/* 视频分类-编辑 */
export function updateSeleniumJourneyVideoCategory(data) {
  return request({
    url: '/selenium/journey/video/category/updateSeleniumJourneyVideoCategory',
    method: 'POST',
    data
  });
}
/* 视频分类-编辑时的信息 */
export function fetchSeleniumJourneyVideoCategoryDetailById(data) {
  return request({
    url: '/selenium/journey/video/category/fetchSeleniumJourneyVideoCategoryDetailById',
    method: 'POST',
    data
  });
}
/* 视频-获取所有分类列表 */
export function querySeleniumJourneyVideoCategoryList(data) {
  return request({
    url: '/selenium/journey/video/category/querySeleniumJourneyVideoCategoryList',
    method: 'POST',
    data
  });
}
/* 视频-列表 */
export function querySeleniumJourneyVideoPageList(data) {
  return request({
    url: '/selenium/journey/video/querySeleniumJourneyVideoPageList',
    method: 'POST',
    data
  });
}
/* 视频-增加 */
export function saveSeleniumJourneyVideo(data) {
  return request({
    url: '/selenium/journey/video/saveSeleniumJourneyVideo',
    method: 'POST',
    data
  });
}
/* 视频-修改 */
export function updateSeleniumJourneyVideo(data) {
  return request({
    url: '/selenium/journey/video/updateSeleniumJourneyVideo',
    method: 'POST',
    data
  });
}
/* 视频-修改的信息展示 */
export function fetchSeleniumJourneyVideoDetailById(data) {
  return request({
    url: '/selenium/journey/video/fetchSeleniumJourneyVideoDetailById',
    method: 'POST',
    data
  });
}
/* 视频-删除 */
export function removeSeleniumJourneyVideoById(data) {
  return request({
    url: '/selenium/journey/video/removeSeleniumJourneyVideoById',
    method: 'POST',
    data
  });
}
/* 视频-修改状态 */
export function updateVideoStatusById(data) {
  return request({
    url: '/selenium/journey/video/updateVideoStatusById',
    method: 'POST',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/xyj.js